import { DriftService } from '@/services/drift-service';

export const driftService = new DriftService();
